import { ReactElement } from 'react';
import { Input } from '@sc/shared-ui';
import { useFieldContext } from './formContext';

export const TextField = ({ label }: { label: string }): ReactElement => {
  const field = useFieldContext<string>();

  return (
    <Input
      label={label}
      value={field.state.value}
      onChange={(e) => field.handleChange(e.target.value)}
      error={field.state.meta.errors.join(', ')}
    />
  );
};
